import { createSlice } from '@reduxjs/toolkit';

export const initialFilterState = {
    schoolClientsFilter: {
        search: "",
        division: "",
        school: "",
        status: { label: "Active", value: "active" },
        sort: {
            column: "lastname",
            direction: "asc",
        },
    },

    notificationsFilter: {
        category: "notification", // notification, action_item
        type: "",
        isRead: null,
        isCompleted: null,
        sort: {
            date: "desc"
        },
    },

    taskPlanTemplateFilter: {
        search: "",
        sort: {
            column: "id",
            direction: "desc",
        },
    },

    supportStaffFilter: {
        search: "",
        status: "",
        school: "",
        support_staff: "",
        plan_client_type: "",
        sort: {
            column: "id",
            direction: "desc",
        },
    },


    supportStaffTaskListFilter: {
        status: "",
        grade: "",
        search: "",
        sort: {
            column: "id",
            direction: "desc",
        },
    },

    taskPlanTemplateLibraryFilter: {
        search: "",
    },

    taskPlanFilter: {
        search: "",
        sort: {
            column: "id",
            direction: "desc",
        },
    },
    homeEducationClientsFilter: {
        search: "",
        division: "",
        school: "",
        status: "",
        sort: {
            column: "lastname",
            direction: "asc"
        }
    },
    chatterClientsFilter: {
        search: "",
        funding_source: "",
        status: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    privateClientsFilter: {
        search: "",
        status: "active",
        start_date: "",
        end_date: "",
        sort: {
            column: "lastname",
            direction: "asc"
        }
    },
    notesFilter: {
        search: "",
        date: "",
        owner: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
    noteCommentsFilter: {
        search: "",
        date: "",
        owner: "",
        sort: {
            column: "id",
            direction: "desc"
        }
    },
}

const filterSlice = createSlice({
    name: 'auth',
    initialState: initialFilterState,
    reducers: {
        schoolClientsFilter: (state, action) => {
            const filter = action.payload;
            state.schoolClientsFilter = filter;
        },
        notificationsFilter: (state, action) => {
            const filter = action.payload;
            state.notificationsFilter = filter;
        },
        taskPlanTemplateFilter: (state, action) => {
            const filter = action.payload;
            state.taskPlanTemplateFilter = filter;
        },
        supportStaffFilter: (state, action) => {
            const filter = action.payload;
            state.supportStaffFilter = filter;
        },
        taskPlanFilter: (state, action) => {
            const filter = action.payload;
            state.taskPlanFilter = filter;
        },

        supportStaffTaskListFilter: (state, action) => {
            const filter = action.payload;
            state.supportStaffTaskListFilter = filter;
        },


        taskPlanTemplateLibraryFilter: (state, action) => {
            const filter = action.payload;
            state.taskPlanTemplateLibraryFilter = filter;
        },
        homeEducationClientsFilter: (state, action) => {
            const filter = action.payload;
            state.homeEducationClientsFilter = filter;
        },
        chatterClientsFilter: (state, action) => {
            const filter = action.payload;
            console.log("payload >>>", action.payload);
            state.chatterClientsFilter = filter;
        },
        privateClientsFilter: (state, action) => {
            const filter = action.payload;
            state.privateClientsFilter = filter;
        },
        notesFilter: (state, action) => {
            const filter = action.payload;
            state.notesFilter = filter;
        },
        noteCommentsFilter: (state, action) => {
            const filter = action.payload;
            state.noteCommentsFilter = filter;
        },
    },
});

export const {
    schoolClientsFilter,
    homeEducationClientsFilter,
    chatterClientsFilter,
    privateClientsFilter,
    notesFilter,
    noteCommentsFilter,
    taskPlanTemplateFilter,
    taskPlanFilter,
    taskPlanTemplateLibraryFilter,
    supportStaffTaskListFilter,
    supportStaffFilter,
    notificationsFilter
} = filterSlice.actions;

export default filterSlice.reducer;